module.exports = "/img/hyundai.f924f62f.png";